import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  overflow-x: hidden !important;

  padding: 0 1rem;

  > div {
    width: 65%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  > div + div {
    margin-top: 24rem;
  }

  @media (max-width: 1700px) {
    > div {
      width: 100%;
    }
  }

  @media (max-width: 500px) {
    padding: 0 0.25rem;

    > div + div {
      margin-top: 16rem;
    }
  }

  .video-modal {
    width: 64.8%;
    height: 65.5%;

    padding: 0.5rem;

    @media (max-width: 1400px) {
      width: 69.8%;
      height: 81.9%;
    }

    @media (max-width: 800px) {
      width: 80%;
      height: 60%;
    }

    @media (orientation: portrait) {
      width: 70%;
      height: 40%;
    }

    @media (orientation: portrait) and (max-width: 500px) {
      width: 90%;
      height: 40%;
    }
  }
`;

export const SloganContainer = styled.div`
  height: calc(100vh - 5.813rem);

  margin-top: 0 !important;
`;

export const SloganContent = styled.div`
  width: 100%;
  height: 100%;

  margin-top: 4.5rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  position: absolute;
  top: 0;
  left: 0;

  h1 {
    font-size: 4.5rem;
    line-height: 6rem;
    font-weight: 700;

    color: ${({ theme }) => theme.colors.gray7};
  }

  span {
    color: ${({ theme }) => theme.colors.secondary};
  }

  p {
    width: 40rem;

    font-size: 1.5rem;
    line-height: 2.4rem;
    font-weight: 400;
    text-align: center;

    color: ${({ theme }) => theme.colors.gray5};

    margin: 2rem 0;
  }

  button:last-of-type {
    width: 6rem;
    height: 6rem;

    border: 2px solid ${({ theme }) => theme.colors.primaryLight};
    border-radius: 100%;

    transition: all 0.2s;

    svg {
      width: 3rem;
      height: 3rem;

      color: ${({ theme }) => theme.colors.primaryLight};

      transition: all 0.2s;
    }

    :hover {
      border: 2px solid ${({ theme }) => theme.colors.primary};

      svg {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  button + button {
    margin-top: 2rem;
  }

  @media (min-width: 1300px) {
    button:first-of-type {
      font-size: 1rem !important;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  @media (max-width: 1400px) {
    h1 {
      font-size: 3.5rem;
      line-height: 4.5rem;
    }

    p {
      width: 35rem;

      font-size: 1.25rem;
      line-height: 2.15rem;
    }

    button:last-of-type {
      width: 5rem;
      height: 5rem;

      svg {
        width: 2rem;
        height: 2rem;
      }
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 3rem;
      line-height: 4rem;
    }

    h1 + h1 {
      margin-top: 1rem;
    }

    p {
      width: 60%;

      font-size: 1rem;
      line-height: 1.75rem;

      margin: 2rem;
    }

    button:last-of-type {
      width: 5rem;
      height: 5rem;

      svg {
        width: 2rem;
        height: 2rem;
      }
    }
  }

  @media (max-width: 600px) {
    height: 100vh;
  }

  @media (max-width: 500px) {
    margin-top: 1.5rem;

    h1 {
      width: 90%;

      font-size: 2.5rem;
      line-height: 3.5rem;
    }

    p {
      width: 70%;
    }
  }
`;

export const Background = styled.div`
  width: 100% !important;

  overflow-x: hidden;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    width: 100%;
  }

  @media (max-width: 710px) {
    img {
      height: calc(100vh - 3rem);

      width: max-content;
    }
  }
`;

export const SVG = styled.svg`
  width: 100%;
  height: calc(100vh - 5.813rem);

  margin-top: 7rem;

  position: absolute;
  top: 0;

  backdrop-filter: blur(50px);
  filter: blur(50px);

  opacity: 0.85;

  .blue-circle {
    fill: ${({ theme }) => theme.colors.primary};
  }

  .pink-circle {
    fill: ${({ theme }) => theme.colors.secondary};
  }

  @media (max-width: 500px) {
    margin-top: 4rem;
  }
`;

export const Circle = styled.circle`
  animation: rotate 5s linear infinite;

  @keyframes rotate {
    from {
      transform: rotate(0);
      transform-origin: center;
    }
    to {
      transform: rotate(360deg);
      transform-origin: center;
    }
  }
`;

export const PlatformContainer = styled.div``;

export const PlatformContent = styled.div`
  width: 53rem;
  height: 31rem;

  position: relative;

  margin-top: 5rem;

  .platform-pink-circle {
    height: 31rem;

    position: absolute;
    top: 0;
  }

  .platform-blue-circle {
    height: 31rem;

    position: absolute;
    top: 0;
    right: 0;
  }

  .company-icon {
    width: 5rem;
    height: 5rem;

    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    filter: drop-shadow(0px 0px 32px rgba(76, 148, 255, 0.48));
  }

  .pink-circle-content {
    position: absolute;

    top: 50%;
    left: 5%;
    transform: translate(0, -50%);
  }

  .blue-circle-content {
    position: absolute;

    top: 50%;
    right: 5%;
    transform: translate(0, -50%);
  }

  @media (max-width: 768px) {
    width: 20rem;
    height: 33rem;

    position: relative;

    .company-icon {
      width: 3rem;
      height: 3rem;
    }

    .platform-pink-circle {
      width: 100%;
      height: fit-content;

      top: 0;
    }

    .platform-blue-circle {
      width: 100%;
      height: fit-content;

      top: 100%;
      transform: translate(0%, -100%);
    }

    .pink-circle-content {
      top: 11%;
      left: 50%;
      transform: translate(-50%, 0%);
    }

    .blue-circle-content {
      bottom: -5%;
      left: 50%;
      transform: translate(-50%, 0%);
    }
  }

  @media (max-width: 500px) {
    width: 15rem !important;
    height: 25rem;

    .platform-pink-circle {
      width: 15rem;
      height: 15rem;

      top: 0;
    }

    .platform-blue-circle {
      width: 15rem;
      height: 15rem;

      bottom: 0;
      transform: translate(0%, -100%);
    }
  }
`;

export const CircleContent = styled.div`
  svg {
    width: 2.15rem;
    height: 2.15rem;
  }

  svg + svg {
    margin-left: 0.417rem;
  }

  p {
    width: 15.188rem;

    font-size: 2rem;
    line-height: 3rem;
    font-weight: 600;

    color: ${({ theme }) => theme.colors.gray7};

    margin-top: 1rem;
  }

  .pink-icons {
    color: ${({ theme }) => theme.colors.secondaryLight};
  }

  .dark-pink-icon {
    color: ${({ theme }) => theme.colors.secondary};
  }

  .blue-icons {
    color: ${({ theme }) => theme.colors.primaryLight};
  }

  .dark-blue-icon {
    color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 1400px) {
    p {
      font-size: 1.75rem;
      line-height: 2.75rem;
    }
  }

  @media (max-width: 768px) {
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    p {
      font-size: 1.5rem;
      line-height: 2.5rem;

      text-align: center;

      margin-top: 0.5rem;
    }

    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  @media (max-width: 500px) {
    p {
      width: 60%;

      font-size: 1rem;
      line-height: 1.5rem;

      text-align: center;

      margin-top: 0.5rem;
    }
  }
`;

export const ModelingContainer = styled.div``;

export const ModelingContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  margin-top: 12rem;

  position: relative;

  img {
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
  }

  .time-series {
    img {
      box-shadow: 0px 3.48571px 27.8857px rgba(159, 122, 234, 0.16);
    }
  }

  .geolocation {
    img {
      box-shadow: 0px 3.48571px 13.9429px rgba(237, 137, 54, 0.16);
    }
  }

  .classification {
    img {
      box-shadow: 0px 13.9434px 27.8867px rgba(56, 178, 172, 0.16);
    }
  }

  @media (max-width: 1225px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 10rem;
  }
`;

export const ModelingCard = styled.div`
  width: 24rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  padding: 2.25rem;

  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray2};
  border-radius: 8px;

  position: relative;

  h1 {
    font-size: 2rem;
    line-height: 3rem;
    font-weight: 600;

    color: ${({ theme }) => theme.colors.gray7};

    margin-top: 0.5rem;
  }

  h3 {
    font-size: 1.25rem;
    line-height: 1.875rem;
    font-weight: 600;

    text-transform: uppercase;
    letter-spacing: 0.08em;

    margin-top: 6.438rem;
  }

  p {
    font-size: 1.25rem;
    line-height: 1.875rem;
    font-weight: 400;

    color: ${({ theme }) => theme.colors.gray5};

    margin-top: 1rem;
  }

  img {
    width: 15.25rem;
    height: 12.5rem;

    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 1400px) {
    h1 {
      font-size: 1.75rem;
      line-height: 2.75rem;
    }
  }

  @media (max-width: 768px) {
    padding: 2rem;

    h1 {
      font-size: 1.5rem;
      line-height: 2.5rem;
    }

    h3 {
      font-size: 1rem;
      line-height: 1.75rem;
    }

    p {
      font-size: 1rem;
      line-height: 1.75rem;
    }
  }

  @media (max-width: 500px) {
    width: 80%;
  }
`;

export const DepartmentContainer = styled.div``;

export const DepartmentContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;

  margin-top: 5rem;

  @media (max-width: 1700px) {
    padding: 0 7rem;
  }

  @media (max-width: 768px) {
    padding: 0 1rem;

    margin-top: 4rem;
  }
`;

type TabContentProps = {
  color: string;
};

export const TabContent = styled.div<TabContentProps>`
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 2.5rem;
    line-height: 3.75rem;
    font-weight: 600;

    color: ${({ theme }) => theme.colors.gray7};

    margin-top: 0.5rem;
    margin-bottom: 2rem;
  }

  p,
  li {
    font-size: 1.5rem;
    line-height: 2.4rem;
    font-weight: 400;

    color: ${({ theme }) => theme.colors.gray5};
  }

  p {
    margin-bottom: 0.5rem;
  }

  li {
    list-style: disc;
    list-style-position: outside;

    margin-left: 1.3rem;
  }

  h3 {
    font-size: 1rem;
    line-height: 2rem;
    font-weight: 600;

    text-transform: uppercase;
    letter-spacing: 0.08em;

    color: ${({ theme }) => theme.colors.primary};
  }

  span {
    color: ${({ color }) => color};
  }

  > div + div {
    margin-left: 4rem;
  }

  > div:first-of-type {
    width: 55%;
    height: 100%;
  }

  > div:not(:first-of-type) {
    width: 45%;
    height: 34rem;

    padding: 2rem;

    background: radial-gradient(
      132.88% 132.88% at -9.32% -32.88%,
      ${({ color }) => color} 0%,
      ${({ theme }) => theme.colors.gray0} 69.62%
    );
    border-radius: 16px;

    overflow: hidden;

    img {
      width: 150%;

      border-radius: 2px;

      filter: drop-shadow(0px 3.10156px 24.8125px rgba(113, 128, 150, 0.2));
    }
  }

  @media (max-width: 1400px) {
    h1 {
      font-size: 2.25rem;
      line-height: 3rem;
    }

    p,
    li {
      font-size: 1.25rem;
      line-height: 2.15rem;
    }

    > div:not(:first-of-type) {
      height: 28rem;
    }
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    text-align: start;

    h3,
    h1 {
      text-align: center;
    }

    > div:first-of-type {
      width: 100% !important;
      height: fit-content;

      margin-bottom: 2rem;
    }

    > div:not(:first-of-type) {
      width: 80% !important;
      height: 15rem;
    }

    > div + div {
      margin-left: 0;
    }

    h1 {
      font-size: 2rem;
      line-height: 3rem;
    }
  }

  @media (max-width: 768px) {
    p,
    li {
      font-size: 1rem;
      line-height: 1.75rem;
    }

    h3 {
      font-size: 0.875rem;
      line-height: 1.75rem;
    }
  }
`;

export const AboutContainer = styled.div``;

export const AboutContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  margin-top: 5rem;
`;

type AboutCardProps = {
  color: string;
  backgroundColor: string;
};

export const AboutCard = styled.div<AboutCardProps>`
  width: 24.063rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  padding: 3rem;

  background: radial-gradient(
    116.51% 116.51% at 37.79% -11.4%,
    ${({ backgroundColor }) => backgroundColor} 0%,
    ${({ theme }) => theme.colors.white} 69.62%
  );
  border: 1px solid ${({ theme }) => theme.colors.gray2};
  border-radius: 16px;

  h1 {
    font-size: 1.75rem;
    line-height: 2.625rem;
    font-weight: 600;

    color: ${({ theme }) => theme.colors.gray6};

    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.25rem;
    line-height: 1.875rem;
    font-weight: 400;

    color: ${({ theme }) => theme.colors.gray5};
  }

  svg {
    width: 4rem;
    height: 4rem;

    color: ${({ color }) => color};
  }

  @media (max-width: 1400px) {
    width: 23rem;

    h1 {
      font-size: 1.65rem;
      line-height: 2.525rem;
    }

    p {
      font-size: 1.15rem;
      line-height: 1.875rem;
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 1.5rem;
      line-height: 2.425rem;
    }

    p {
      font-size: 1rem;
      line-height: 1.75rem;
    }
  }

  @media (max-width: 500px) {
    width: 80%;

    padding: 3rem 2rem;
  }
`;

export const CasesContainer = styled.div``;

export const CasesContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-top: 5rem;
`;

export const VideoContainer = styled.div``;

export const VideoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;

  cursor: pointer;

  img {
    width: 70%;

    border-top: 4px solid;
    border-image-source: linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.primary} 0%,
      ${({ theme }) => theme.colors.secondary} 100%
    );
    border-image-slice: 1;

    mask-image: linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.white},
      rgba(0, 0, 0, 0) 70%
    );
  }

  svg {
    width: 6.25rem;
    height: 6.25rem;

    color: ${({ theme }) => theme.colors.primary};

    margin-bottom: 3rem;

    mask-image: linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.white},
      ${({ theme }) => theme.colors.white}
    );
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-top: -25%;
  }

  @media (min-width: 1700px) {
    img {
      width: 100%;
    }

    > div {
      margin-top: -35%;
    }

    svg {
      width: 7rem;
      height: 7rem;
    }
  }

  @media (max-width: 768px) {
    img {
      width: 90%;
    }

    svg {
      width: 4rem;
      height: 4rem;
    }
  }
`;

export const PlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PlansContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-top: 8rem;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1.75rem;

    margin-bottom: 3rem;
  }

  button {
    width: fit-content;

    padding: 0.75rem 3rem;
  }

  @media (max-width: 1160px) {
    > div {
      flex-direction: column;
      gap: 6rem;
    }
  }

  @media (min-width: 1300px) {
    button {
      font-size: 1rem !important;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
`;

export const PlanCard = styled.div`
  width: 45%;

  padding: 3rem 2rem;

  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.gray2};

  position: relative;

  h2 {
    color: ${({ theme }) => theme.colors.gray6};
    text-align: center;
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.5rem;

    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
  }

  h4 {
    text-align: center;
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 160%;
    letter-spacing: 0.09rem;
    text-transform: uppercase;

    color: ${({ theme }) => theme.colors.gray7};

    margin-top: 2.5rem;
  }

  p {
    color: ${({ theme }) => theme.colors.gray5};

    text-align: center;
    font-size: 1.25rem;
    line-height: 150%;
  }

  &:first-of-type {
    background: radial-gradient(
        124.59% 124.59% at 50% -70.73%,
        rgba(255, 171, 211, 0.28) 0%,
        rgba(255, 171, 211, 0) 100%
      ),
      #fff;

    div {
      width: 7.5rem;
      height: 7.5rem;

      position: absolute;
      top: -3.75rem;
      left: calc(50% - 3.75rem);

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 100%;
      border: 2px solid rgba(242, 125, 180, 0.25);
      background: linear-gradient(
          0deg,
          rgba(255, 171, 211, 0.12) 0%,
          rgba(255, 171, 211, 0.12) 100%
        ),
        #fff;
      box-shadow: 0px 12px 32px 0px rgba(242, 125, 180, 0.18);
    }
  }

  &:last-of-type {
    background: radial-gradient(
        144.67% 118.34% at 0% -68.38%,
        rgba(255, 171, 211, 0.2) 0%,
        rgba(255, 171, 211, 0) 100%
      ),
      radial-gradient(
        156.11% 132.08% at 100% -83.37%,
        rgba(129, 179, 255, 0.2) 0%,
        rgba(129, 179, 255, 0) 100%
      ),
      #fff;

    div {
      width: 13.5rem;
      height: 7.5rem;

      position: absolute;
      top: -3.75rem;
      left: calc(50% - 6.75rem);

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 9999px;
      border: 2px solid rgba(129, 179, 255, 0.36);
      background: linear-gradient(
          307deg,
          rgba(129, 179, 255, 0.12) 22.24%,
          rgba(255, 171, 211, 0.12) 67.83%
        ),
        #fff;
      box-shadow: 0px 12px 32px 0px rgba(76, 148, 255, 0.12);
    }
  }

  @media (max-width: 1400px) {
    width: 40%;

    p {
      font-size: 1.15rem;
      line-height: 1.875rem;
    }

    h1 {
      font-size: 1.65rem;
      line-height: 2.525rem;
    }
  }

  @media (max-width: 1366px) {
    &:first-of-type {
      div {
        width: 5rem;
        height: 5rem;

        top: -2.5rem;
        left: calc(50% - 2.5rem);

        img {
          height: 4rem;
        }
      }

      h4 {
        margin-top: 2rem;
      }
    }

    &:last-of-type {
      div {
        width: 11rem;
        height: 5rem;

        top: -2.5rem;
        left: calc(50% - 5.5rem);

        img {
          height: 4rem;
        }
      }

      h4 {
        margin-top: 2rem;
      }
    }
  }

  @media (max-width: 1250px) {
    width: 50%;
  }

  @media (max-width: 1000px) {
    width: 70%;
  }

  @media (max-width: 768px) {
    width: 80%;

    p {
      font-size: 1rem;
      line-height: 1.75rem;
    }

    h1 {
      font-size: 1.5rem;
      line-height: 2.425rem;
    }

    h4 {
      font-size: 1rem;
    }
  }

  @media (max-width: 500px) {
    width: 90%;

    padding: 2.5rem 1.5rem;

    &:first-of-type {
      div {
        width: 4rem;
        height: 4rem;

        top: -2rem;
        left: calc(50% - 2rem);

        img {
          height: 3rem;
        }
      }

      h4 {
        margin-top: 1rem;
      }
    }

    &:last-of-type {
      div {
        width: 10rem;
        height: 4rem;

        top: -2rem;
        left: calc(50% - 5rem);

        img {
          height: 3rem;
        }
      }

      h4 {
        margin-top: 1rem;
      }
    }
  }
`;
